(function () {
  function init(root) {
    if (root.dataset.f24HighlightsReady === "true") return;
    root.dataset.f24HighlightsReady = "true";

    var track = root.querySelector(".f24-highlights__track");
    var cards = Array.prototype.slice.call(root.querySelectorAll(".f24-highlights__card"));
    var dots = Array.prototype.slice.call(root.querySelectorAll(".f24-highlights__dot"));
    var play = root.querySelector(".f24-highlights__play");
    var duration = Math.max(1800, Number(root.dataset.slideDuration || 5200));
    var active = 0;
    var playing = root.dataset.autoplay === "true";
    var userWantsPlaying = playing;
    var rootVisible = false;
    var hasStartedOnce = false;
    var programmaticScrollUntil = 0;
    var scrollEndTimer = null;
    var positionTimer = null;
    var visibilityRaf = null;
    var timer = null;

    if (!track || !cards.length) return;

    function applyTrackLayout() {
      var isMobile = window.matchMedia && window.matchMedia("(max-width: 760px)").matches;
      var padding = isMobile
        ? "0 20px 22px"
        : "0 max(24px, calc((100% - min(78vw, 980px)) / 2)) 22px";
      track.style.setProperty("padding", padding, "important");
    }

    function setPositioning(enabled) {
      track.classList.toggle("is-positioning", enabled);
      if (enabled) {
        track.style.setProperty("scroll-snap-type", "none", "important");
      } else {
        track.style.removeProperty("scroll-snap-type");
      }
    }

    function sectionIsInFocus() {
      var rect = root.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top <= viewportHeight * 0.42 && rect.bottom >= viewportHeight * 0.62;
    }

    function clampScrollLeft(value) {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      return Math.max(0, Math.min(value, max));
    }

    function targetLeftFor(index) {
      if (index === 0) return 0;
      var card = cards[index];
      return clampScrollLeft(card.offsetLeft - (track.clientWidth - card.clientWidth) / 2);
    }

    function activeVideo() {
      return cards[active] && cards[active].querySelector("video");
    }

    function pauseAll(resetInactive) {
      cards.forEach(function (card, index) {
        var video = card.querySelector("video");
        if (!video) return;
        if (index !== active || resetInactive) {
          video.pause();
          if (index !== active) video.currentTime = 0;
        }
      });
    }

    function activeCard() {
      return cards[active];
    }

    function videoSpeed(video) {
      var card = activeCard();
      var speed = Number((card && card.dataset.videoSpeed) || 1);
      return Number.isFinite(speed) && speed > 0 ? speed : 1;
    }

    function effectiveVideoDuration(video) {
      if (!video || !Number.isFinite(video.duration) || video.duration <= 0) return 0;
      return (video.duration / videoSpeed(video)) * 1000;
    }

    function schedule() {
      window.clearTimeout(timer);
      if (!playing || !rootVisible) return;
      var video = activeVideo();
      var videoDuration = effectiveVideoDuration(video);
      var wait = Math.max(duration, videoDuration || duration);
      if (video && !videoDuration) {
        video.addEventListener("loadedmetadata", schedule, { once: true });
      }
      timer = window.setTimeout(function () {
        goTo((active + 1) % cards.length, true);
      }, wait);
    }

    function updateControls() {
      dots.forEach(function (dot, index) {
        dot.classList.toggle("is-active", index === active);
        dot.setAttribute("aria-current", index === active ? "true" : "false");
      });
      if (play) {
        play.classList.toggle("is-playing", playing);
        play.setAttribute("aria-label", playing ? "Highlights pausieren" : "Highlights abspielen");
      }
    }

    function playActiveVideo() {
      pauseAll(false);
      var video = activeVideo();
      if (!video) {
        schedule();
        return;
      }
      video.loop = false;
      video.muted = true;
      video.playsInline = true;
      video.playbackRate = videoSpeed(video);
      try {
        video.currentTime = 0;
      } catch (error) {
        video.addEventListener("loadedmetadata", function () {
          try { video.currentTime = 0; } catch (e) { return undefined; }
        }, { once: true });
      }
      if (playing && rootVisible) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            video.addEventListener("canplay", function () {
              if (playing && rootVisible && video === activeVideo()) {
                video.play().catch(function () { return undefined; });
              }
            }, { once: true });
          });
        }
      }
    }

    function settlePosition() {
      setPositioning(false);
      var index = nearestCardIndex();
      if (index === active) return;
      active = index;
      playing = userWantsPlaying;
      updateControls();
      playActiveVideo();
      schedule();
    }

    function goTo(index, fromAuto, instant) {
      active = (index + cards.length) % cards.length;
      var targetLeft = targetLeftFor(active);
      programmaticScrollUntil = Date.now() + (instant ? 420 : 1400);
      window.clearTimeout(positionTimer);
      setPositioning(true);
      if (instant) {
        track.scrollLeft = targetLeft;
      } else {
        track.scrollTo({ left: targetLeft, behavior: fromAuto ? "smooth" : "smooth" });
      }
      updateControls();
      playActiveVideo();
      schedule();
      positionTimer = window.setTimeout(settlePosition, instant ? 90 : 760);
    }

    function nearestCardIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var bestIndex = 0;
      var bestDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + card.clientWidth / 2;
        var distance = Math.abs(center - cardCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        playing = false;
        userWantsPlaying = false;
        goTo(index, false, false);
        updateControls();
      });
    });

    if (play) {
      play.addEventListener("click", function () {
        playing = !playing;
        userWantsPlaying = playing;
        updateControls();
        if (playing) {
          playActiveVideo();
          schedule();
        } else {
          window.clearTimeout(timer);
          pauseAll(true);
        }
      });
    }

    var mouseDragging = false;
    var mouseMoved = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    track.addEventListener("pointerdown", function (event) {
      if (event.pointerType && event.pointerType !== "mouse") return;
      if (event.button !== 0) return;

      mouseDragging = true;
      mouseMoved = false;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add("is-dragging");
      setPositioning(true);
      track.setPointerCapture(event.pointerId);
      window.clearTimeout(timer);
      window.clearTimeout(positionTimer);
    });

    track.addEventListener("pointermove", function (event) {
      if (!mouseDragging) return;
      var delta = event.clientX - dragStartX;
      if (Math.abs(delta) > 4) mouseMoved = true;
      track.scrollLeft = dragStartScroll - delta;
    });

    function finishMouseDrag(event) {
      if (!mouseDragging) return;
      mouseDragging = false;
      track.classList.remove("is-dragging");
      if (event && track.hasPointerCapture && track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
      if (mouseMoved) {
        playing = userWantsPlaying;
        goTo(nearestCardIndex(), false, false);
        updateControls();
      } else {
        setPositioning(false);
      }
    }

    track.addEventListener("pointerup", finishMouseDrag);
    track.addEventListener("pointercancel", finishMouseDrag);
    track.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });

    track.addEventListener("scroll", function () {
      if (Date.now() < programmaticScrollUntil || mouseDragging) return;
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        var index = nearestCardIndex();
        if (index === active) return;
        active = index;
        playing = userWantsPlaying;
        updateControls();
        playActiveVideo();
        schedule();
      }, 140);
    }, { passive: true });

    cards.forEach(function (card, index) {
      var video = card.querySelector("video");
      if (!video) return;
      video.addEventListener("ended", function () {
        video.pause();
        updateControls();
      });
    });

    function updateVisibility() {
      visibilityRaf = null;
      var shouldRun = sectionIsInFocus();
      if (shouldRun === rootVisible && hasStartedOnce) return;
      rootVisible = shouldRun;
      window.clearTimeout(timer);
      if (!rootVisible) {
        pauseAll(false);
        return;
      }
      if (userWantsPlaying) {
        playing = true;
        if (!hasStartedOnce) {
          hasStartedOnce = true;
          goTo(0, false, true);
        } else {
          updateControls();
          playActiveVideo();
          schedule();
        }
      }
    }

    function requestVisibilityUpdate() {
      if (visibilityRaf) return;
      visibilityRaf = window.requestAnimationFrame(updateVisibility);
    }

    applyTrackLayout();
    programmaticScrollUntil = Date.now() + 500;
    setPositioning(true);
    track.scrollLeft = 0;
    window.setTimeout(function () {
      setPositioning(false);
    }, 100);

    window.addEventListener("scroll", requestVisibilityUpdate, { passive: true });
    window.addEventListener("resize", function () {
      applyTrackLayout();
      goTo(active, false, true);
      requestVisibilityUpdate();
    });
    updateControls();
    requestVisibilityUpdate();
  }

  document.querySelectorAll(".f24-highlights").forEach(init);
})();
